import {
	EmailModel,
	PasswordSetModel,
	PhoneNumberModel,
	PhoneVerificationModel,
	SmsEmailVerifyModel,
	TokenModel,
} from "../models/Verification.model";

function tokenDto(token: string): TokenModel {
	return {
		apt_val: token,
	};
}

function emailDto(email: string, origin: string): EmailModel {
	return {
		email: email,
		origin: origin,
	};
}


function getPhoneNumberDto(phoneNumber: string): PhoneNumberModel {
	const formattedPhoneNumber = phoneNumber.replace(/ /g, "");
	return {
		phone_number: formattedPhoneNumber,
	};
}

function getPhoneVerificationDto(aptPin: string, phoneNumber: string): PhoneVerificationModel {
	const formattedPhoneNumber = phoneNumber.replace(/ /g, "");
	return {
		apt_pin: aptPin,
		phone_number: formattedPhoneNumber,
	};
}

function getPhoneEmailVerificationDto(aptPin: string, phoneNumber: string, email: string): SmsEmailVerifyModel {
	const formattedPhoneNumber = phoneNumber.replace(/ /g, "");
	return {
		apt_pin: aptPin,
		phone_number: formattedPhoneNumber,
		email: email,
	};
}

function getSetPswDto(aptVal: string, type: string, userName: string, password: string): PasswordSetModel {
	return {
		token: aptVal,
		type: type,
		username: userName,
		password: password,
	};
}

export { tokenDto, emailDto, getPhoneNumberDto, getPhoneVerificationDto, getPhoneEmailVerificationDto, getSetPswDto };
